import ApiNode from './ApiNode'

export default {
    getSlineApprovalList(params) {
        return ApiNode().get('sline-approval/list', { params });
    },
    approveSline(params) {
        return ApiNode().post('sline-approval/approve', params);
    },
    rejectSline(params) {
        return ApiNode().post('sline-approval/reject', params);
    }
}



// WEBPACK FOOTER //
// ./src/services/SlineApprovalService.js